// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__LDnWN","videoContainer":"Card_videoContainer__qPpcM","CardText":"Card_CardText__smKOh","CardTexth4":"Card_CardTexth4__mBcRp","greyText":"Card_greyText__GQs-C"};